import { Component, OnInit } from '@angular/core';
import { navItems } from '../../_nav';
import { EmisorService } from '../../emisor.service';
import { Emisor } from '../../emisor';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  usuario: string;
  local: string;
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }

  constructor(

    private apiEmisor: EmisorService) {

  }

  ngOnInit(): void {
    this.usuario = (localStorage.getItem('usuario'));
    this.apiEmisor.getEmisor(localStorage.getItem('id')).subscribe((data: Emisor[]) => {
      console.log(data);
      data.forEach(item => {
        this.local = item.razonsocial;
      
      });
    });

  }


}
